package com.elan.edubridge.ui.staff

import com.elan.edubridge.ui.staff.externals.toDataURL
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.await
import org.w3c.dom.HTMLElement

/**
 * QR 렌더링(가이드 §3.5, 계획 Q9 — npm `qrcode` 선택). [externals.toDataURL]을
 * 감싸 컨테이너 요소 안에 `<img>`로 그린다. 실패(라이브러리 로드 실패 등)하면 안내 텍스트로 대체한다.
 */
object QrRenderer {
    suspend fun renderInto(container: HTMLElement, payload: String, pixelSize: Int) {
        val options: dynamic = js("({})")
        options.width = pixelSize
        options.margin = 1
        options.errorCorrectionLevel = "M"
        // 스캐너 인식률을 위해 흑백 고대비 유지 — 브랜드 컬러 착색 금지(가이드 §3.5.3).
        // dynamic 값에는 stdlib 확장 함수(also 등)가 아니라 평범한 대입으로 채운다 —
        // dynamic 위의 `.also { }`는 JS 프로퍼티 호출로 해석돼 컴파일러가 `it`을 못 잡는다.
        val color: dynamic = js("({})")
        color.dark = "#000000"
        color.light = "#ffffff"
        options.color = color
        try {
            val dataUrl = toDataURL(payload, options).await()
            container.innerHTML = """<img src="$dataUrl" alt="" role="presentation">"""
        } catch (error: CancellationException) {
            throw error
        } catch (error: Throwable) {
            console.error("[EduBridge] QR 렌더링 실패", error)
            container.innerHTML = """<span class="eb-meta">QR을 표시할 수 없어요.</span>"""
        }
    }

    /** §3.6 QR 페이로드 형식. nonce는 서버가 [rotateQrToken]/[createQrSession] 응답으로 준 값을 그대로 옮긴다. */
    fun payload(academyId: String, sessionId: String, nonce: String): String =
        "https://elan-edubridge.web.app/qr?a=$academyId&s=$sessionId&n=$nonce"
}
